export default __webpack_public_path__ + "static/krispcall-hero-img-074d844ccb5cf6f8010e58066a72edee.webp";